import { Form as FormRFF, Field as FieldRFF } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import { UserLoginViewModel } from 'api/utility/utility.model';
import Button from 'components/Buttons';
import Form from 'components/Form';
import Input from 'components/Form/Input';
import { useAuthenticatedContext } from 'hooks/useAuthenticated';
import useValidationSchema from 'hooks/useValidationSchema';
import { COMPANY } from 'models/company.model';

import { useSchema } from './schema';

export enum LOGIN_TYPES {
  MOBILE_APP = 'MOBILE_APP',
  PASSWORD = 'PASSWORD',
}
interface LoginFormProps {
  company: COMPANY;
  loginType: LOGIN_TYPES;
}

const LoginForm = ({ company, loginType }: LoginFormProps) => {
  const isPasswordLogin = loginType === LOGIN_TYPES.PASSWORD;
  const { t } = useTranslation();
  const schema = useSchema(isPasswordLogin);
  const validate = useValidationSchema(schema);
  const { isLoading, loginError, handleLogin, handleFullIdentityLogin, clearLoginError } =
    useAuthenticatedContext();

  const handleSubmitLogin = (values: UserLoginViewModel) => {
    clearLoginError();
    if (isPasswordLogin) {
      handleLogin(values, company);
      return;
    }
    handleFullIdentityLogin(values, company);
  };

  return (
    <>
      <FormRFF<UserLoginViewModel>
        onSubmit={handleSubmitLogin}
        validate={validate}
        initialValues={{ username: '' }}
      >
        {({ handleSubmit }) => (
          <Form onSubmit={handleSubmit} data-cy="form">
            <FieldRFF
              name="username"
              label={t('loginPage.usernameLabel')}
              placeholder={t('loginPage.usernamePlaceholder')}
              data-cy="form_username"
              required
              component={Input}
              submitError={{ username: loginError }}
              clearSubmitError={clearLoginError}
            />

            {isPasswordLogin && (
              <FieldRFF
                name="password"
                type="password"
                label={t('loginPage.password')}
                placeholder={t('loginPage.passwordPlaceholder')}
                data-cy="form_password"
                required
                component={Input}
              />
            )}

            <div>
              <Button
                type="primary"
                htmlType="submit"
                data-cy="form_submit"
                $block
                loading={isLoading}
                disabled={isLoading}
              >
                {t('loginPage.login')}
              </Button>
            </div>
          </Form>
        )}
      </FormRFF>
    </>
  );
};

export default LoginForm;
